import { color } from '@/theme/tokens';
import styled from '@emotion/styled';
import TextFieldFilled from './TextFieldFilled';

export const TextFieldFilledWhite = styled(TextFieldFilled)`
    & .MuiInputBase-root {
        background-color: ${color.white[0]} !important;

        &:hover {
            background-color: ${color.white[0]} !important;
        }

        &.Mui-focused {
            background-color: ${color.white[0]} !important;
        }

        & .Mui-disabled {
            background-color: ${color.white[0]} !important;
        }
    }
`;
